
/*
 * VNCtalk - an enterprise real-time communication solution including chat, video and audio conferencing, screen sharing, voice messaging, file sharing, broadcasts, document collaboration and much more.
 * Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, version 3 of the License.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. Look for COPYING file in the top folder.
 * If not, see http://www.gnu.org/licenses/.
 */

import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, Inject, NgZone, OnDestroy } from "@angular/core";
import { Broadcaster } from "../../../providers/broadcaster.service";
import { debounceTime, distinctUntilChanged, filter, map, Subject, switchMap, take, takeUntil, timer } from "rxjs";
import { ConversationRepository } from "../../../../repositories/conversation.repository";
import { JID } from "../../../../models/jid.model";
import { TalkRootState, getSelectedConversation, getConversationOwner } from "../../../../reducers";
import { Store } from "@ngrx/store";
import { getUserJID, getUserProfile } from "../../../../../reducers";
import { Conversation } from "../../../../models/conversation.model";
import { ContactRepository } from "../../../../repositories/contact.repository";
import { ToastService } from "../../../../../shared/services/toast.service";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ChannelRepository } from "app/channels/repository/channel.repository";
import { ChannelService } from "app/channels/channel.service";
import { OnInit } from "@angular/core";
import { SnackbarType } from "app/channels/models/snackbar.model";
import { Router } from "@angular/router";
import { Channel } from "angular2-actioncable";
import { CommonUtil } from "app/talk/utils/common.util";
import { LoggerService } from "app/shared/services/logger.service";
import { BreakpointObserver, BreakpointState } from "@angular/cdk/layout";
import { Member } from "app/channels/models/member.model";
import { UntypedFormControl } from "@angular/forms";
import { AvatarRepository } from "app/talk/repositories/avatar.repository";

@Component({
  templateUrl: "./full-view-image.html",
  styleUrls: ["./full-view-image.scss"],  // Use 'styleUrls' for external stylesheets
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class FullViewImageComponent implements OnDestroy {

  imageURl: string = "";
  private isAlive$ = new Subject<boolean>();
  constructor(private broadcaster: Broadcaster,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialogRef<FullViewImageComponent>,
    private changeDetectionRef: ChangeDetectorRef) {
     this.imageURl = this.data.imageURL;
    this.broadcaster.on<any>("closeDialog")
      .pipe(takeUntil(this.isAlive$))
      .subscribe(() => {
        this.dialog.close();
      });
  }

  ngOnInit() {

  }

  ngOnDestroy() {
    this.isAlive$.next(false);
    this.isAlive$.complete();
    if (document.querySelector(".dialog-backdrop") !== null) {
      (<HTMLElement>document.querySelector(".dialog-backdrop")).style.display = "none";
    }
  }
}
